// src/pages/settings/loads/LoadsLayout.jsx
import { NavLink, Outlet } from 'react-router-dom';

export default function LoadsLayout() {
  return (
    <div className="card">
      <div className="flex-between">
        <h2 className="card__title">Reference: Templates</h2>
      </div>

      <nav className="organization-tabs subtabs" role="tablist" aria-label="Loads Sub Tabs">
        <NavLink
          to="/organization/loads/templates"
          className={({ isActive }) => `settings-tabs__item ${isActive ? 'is-active' : ''}`}
        >
          Loads
        </NavLink>
        <NavLink
          to="/organization/loads/pallet-sizes"
          className={({ isActive }) => `settings-tabs__item ${isActive ? 'is-active' : ''}`}
        >
          Pallet Sizes
        </NavLink>
      </nav>

      <Outlet />
    </div>
  );
}
